import React from 'react';
import { Background, Wrapper, Logo, Copy, Disclaimer, SiteMapWrapper, SiteMap, Portfolios, About, Title, List, ListItem, Link, ListWrapper, Column, TopElement, BottomElement} from './index.styled';
import mobileLogo from '../SiteNavigation/logo-mobile.png';
import { useTranslation } from 'react-i18next';
import { useMobileBreakpoint } from '../breakpoints';
import { MobileFooter } from './components/MobileFooter';

const SiteFooter = ( ) => {
  const { t } = useTranslation();
  const altLogo = t(`FooterData.altLogo`)
  const isMobile  = useMobileBreakpoint();
  const disclaimer = t(`FooterData.disclaimer`, {returnObjects: true})


  const scrollTop = () =>{
    window.scrollTo({top: 0, scrollBehavior: 'smooth'});
  };
  return (
    <Background>
      {
        isMobile ? (
          <MobileFooter logo={mobileLogo} altLogo={altLogo} disclaimer={disclaimer} />
        ):
        (
          <Wrapper>
            <Column>
              <TopElement>
                <Logo><img src={mobileLogo} alt={altLogo} /></Logo>
              </TopElement>
              <SiteMapWrapper>
                <SiteMap>
                  <Title>{t('FooterData.sitemap.title')}</Title>
                  <Title>{t('FooterData.sitemap.sitename')}</Title>
                </SiteMap>
              </SiteMapWrapper>
            </Column>
            <Column>
              <TopElement>
                <Copy>{'©' + new Date().getFullYear() + ' ' + t('FooterData.copyRight')}</Copy>
              </TopElement>
              <BottomElement>
                <Portfolios>
                  <Link to='/portfolios' onClick={scrollTop}>
                    <Title>{t('FooterData.sitemap.portfolios.title')}</Title>
                  </Link>
                  <ListWrapper>
                    <List>
                      <ListItem onClick={scrollTop}>
                        <Link to='/portfolios/materials'>{t('FooterData.sitemap.portfolios.list.0.title')}</Link>
                      </ListItem>
                      <ListItem onClick={scrollTop}>
                        <Link to='/portfolios/electronics'>{t('FooterData.sitemap.portfolios.list.1.title')}</Link>
                      </ListItem>
                      <ListItem onClick={scrollTop}>
                        <Link to='/portfolios/robotics'>{t('FooterData.sitemap.portfolios.list.2.title')}</Link>
                      </ListItem>
                    </List>
                    <List>
                      <ListItem onClick={scrollTop}>
                        <Link to='/portfolios/mobility'>{t('FooterData.sitemap.portfolios.list.3.title')}</Link>
                      </ListItem>
                      <ListItem onClick={scrollTop}>
                        <Link to='/portfolios/manufacturing'>{t('FooterData.sitemap.portfolios.list.4.title')}</Link>
                      </ListItem>
                    </List>
                  </ListWrapper>
                </Portfolios>
              </BottomElement>
            </Column>
            <Column>
              <TopElement>
                <Disclaimer>
                  <a href={disclaimer.privacyPolicy.url}>{t('FooterData.disclaimer.privacyPolicy.title')}&nbsp;</a>
                  <a href={disclaimer.legalTerms.url}>{t('FooterData.disclaimer.legalTerms.title')}</a>
                </Disclaimer>
              </TopElement>
              <BottomElement>
                <About>
                  <Link to='/about' onClick={scrollTop}>
                    <Title>{t('FooterData.sitemap.aboutUs.title')}</Title>
                  </Link>
                  <ListWrapper>
                  <List>
                    <ListItem>
                      <Link to='/about/global-facilities' href='#global-facilities' >{t('FooterData.sitemap.aboutUs.list.0.title')}</Link>
                    </ListItem>
                    {/* <ListItem>
                      <Link to='/about/team'>{t('FooterData.sitemap.aboutUs.list.1.title')}</Link>
                    </ListItem> */}
                    <ListItem>
                      <Link to='/about/partnership' href='#partnership' >{t('FooterData.sitemap.aboutUs.list.2.title')}</Link>
                    </ListItem>
                  </List>
                    <List>
                      {/* <ListItem>
                        <Link to='/about/newsroom' href='#newsroom' >{t('FooterData.sitemap.aboutUs.list.3.title')}</Link>
                      </ListItem> */}
                      {/* <ListItem>
                        <Link to='/about/social-benefits'>{t('FooterData.sitemap.aboutUs.list.4.title')}</Link>
                      </ListItem> */}
                    </List>
                  </ListWrapper>
                </About>
              </BottomElement>
            </Column>
          </Wrapper>
        )
      }
    </Background>
  );
};

export default SiteFooter;
